<template>
    <div>
        <top :title="title"></top>
        
        <!-- 新增搜索框 -->
        <div class="search-box" v-if="showSearch">
            <div class="search-input">
                <input
                    type="search"
                    v-model="styleCode"
                    placeholder="搜索款号"
                    @keyup.enter="handleSearch"
                    @search="handleSearch"
                    inputmode="search"
                >
                <div class="search-btn" @click="handleSearch">
                    <!-- <img src="@/assets/img/search-icon.png" alt="搜索"> -->
                     <i class="el-icon-search"></i>
                </div>
            </div>
        </div>
        
        <div class="order-con" :class="{ 'with-search': showSearch }">
            <div class="order-item" v-for="(item, index) in list" :key="index">
                <div class="title flex ali-cen jusc-be">
                    <div>No:{{ item.styleCode }}</div>
                    <div class="status">{{ item.name }}</div>
                </div>
                <div class="oder-info">
                    <!-- <img class="good-img" :src="item.img.split(',')[0]"></img> -->
                    <image-preview class="good-img" :src="item.img" :width="62" :height="62" />
                    <div class="infos ">
                        <div class="style">面料：{{ item.fabricName }}</div>
                        <div class="style">纸样：{{ item.patternName }}</div>
                    </div>
                </div>
            </div>
            
            <!-- 无搜索结果提示 -->
            <div class="empty-tip" v-if="list.length === 0">
                <p>未找到相关数据</p>
            </div>
        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue'
import { getStylePage} from "@/http/index";

export default {
    components: { top },
    data() {
        return {
            list: [],
            title: '',
            styleCode: '',     
            showSearch: true,   
        };
    },
    created() {
        this.getList();
    },
    watch: {
        searchText(newVal) {
            this.filterOrders(newVal);
        }
    },
    methods: {
        getList() {
            this.title = '款号列表'
            getStylePage({
                pageNum: 1,
                pageSize: 1000,
                styleCode:this.styleCode
            }).then(res => {
                this.list = res.rows;
            })
        },
        handleSearch() {
            this.getList();
        },
    }
};
</script>

<style lang="scss" scoped>
/* 新增搜索框样式 */
.search-box {
    padding: 12px 24px 0;
    background-color: #f7f8fa;
    
    .search-input {
        position: relative;
        display: flex;
        align-items: center;
        
        input {
            flex: 1;
            height: 36px;
            padding: 0 15px 0 40px;
            border: 1px solid #e4e7ed;
            border-radius: 18px;
            background-color: #fff;
            font-size: 14px;
            color: #303133;
            
            &:focus {
                outline: none;
                border-color: #E44338;
            }
            
            &::placeholder {
                color: #c0c4cc;
            }
        }
        
        .search-btn {
            position: absolute;
            left: 12px;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }
}

.order-con {
    background-color: #f7f8fa;
    padding: 24px;
    height: 100vh;
    
    &.with-search {
        padding-top: 12px;
    }

    .order-item {
        background: #ffffff;
        border-radius: 6px;
        padding: 12px;
        margin-bottom: 12px;

        .title {
            font-size: 14px;
            color: #303133;
            margin-bottom: 16px;
            font-weight: bold;
        }

        .status {
            font-weight: 600;
            font-size: 14px;
        }

        .oder-info {
            display: flex;
            align-items: center;

            .good-img {
                width: 90px;
                height: 62px;
                border-radius: 4px;
                margin-right: 10px;
            }

            .infos {
                flex: 1;
            }

            .style {
                font-weight: 500;
                font-size: 14px;
                color: #303133;
            }

            .num {
                text-align: right;
                font-weight: 500;
                font-size: 14px;
                color: #909399;
            }

            .time {
                font-weight: 400;
                font-size: 13px;
                color: #303133;
                margin-top: 10px;
            }
        }

        .btn-box {
            display: flex;
            justify-content: flex-end;
            margin-top: 16px;

            .use-btn {
                padding: 4px 12px;
                background: #FFFFFF;
                border-radius: 30px;
                border: 1px solid #E24A41;
                font-weight: 600;
                font-size: 14px;
                color: #E44338;
            }
        }
    }
    
    /* 新增：无搜索结果提示 */
    .empty-tip {
        text-align: center;
        padding: 60px 20px;
        
        .empty-icon {
            width: 120px;
            height: 120px;
            margin-bottom: 20px;
            opacity: 0.6;
        }
        
        p {
            color: #909399;
            font-size: 14px;
        }
    }
}
</style>